var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 19 17" }, props),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M16.7 3.5H2.3c-1.1 0-2 .9-2 2V11c0 1.1.9 2 2 2h2.4v4h10v-4h1.9c1.1 0 2-.9 2-2V5.5c.1-1.1-.8-2-1.9-2zM12.8 15h-6v-2h6v2zM4.8 0h10v2h-10z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Print.svg